import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassQuestions extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassQuestions'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: null,
      position: 0,
      subCategoryId: null,
      compassSubCategoryId: null,
      title: '',
      description: '',
      standardQuestionId: null,
      userId: null,
      compassCategoryId: null,
    }
  }
}
const servicePath = 'compass-questions'
const servicePlugin = makeServicePlugin({
  Model: CompassQuestions,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
